var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import React, { useState } from "react";
import { Person, X, Check } from "@reverb-ui/icons-react";
import { Box, HStack, IconButton, Table, Tbody, Td, Text, Th, Thead, Tr, } from "@reverb-ui/react";
export var UserRequestTable = function (_a) {
    var userRequestJoin = _a.userRequestJoin, columnTitle = _a.columnTitle, approveUserRequestAndBindEmployee = _a.approveUserRequestAndBindEmployee, rejectRequestJoinId = _a.rejectRequestJoinId, selectedClient = _a.selectedClient;
    var _b = useState(false), loading = _b[0], setLoading = _b[1];
    var approveRequest = function () { return __awaiter(void 0, void 0, void 0, function () {
        var email, id;
        return __generator(this, function (_a) {
            email = userRequestJoin.email, id = userRequestJoin.id;
            if ((selectedClient === null || selectedClient === void 0 ? void 0 : selectedClient.value) && (selectedClient === null || selectedClient === void 0 ? void 0 : selectedClient.locationId)) {
                setLoading(true);
                approveUserRequestAndBindEmployee({
                    userRequestJoinId: id,
                    userRequestJoinEmail: email,
                    clientRockId: selectedClient === null || selectedClient === void 0 ? void 0 : selectedClient.value,
                    locationId: selectedClient.locationId,
                }).finally(function () { return setLoading(false); });
            }
            return [2 /*return*/];
        });
    }); };
    var rejectRequest = function () { return __awaiter(void 0, void 0, void 0, function () {
        var id;
        return __generator(this, function (_a) {
            id = userRequestJoin.id;
            setLoading(true);
            rejectRequestJoinId(id).finally(function () { return setLoading(false); });
            return [2 /*return*/];
        });
    }); };
    return (React.createElement(Table, null,
        React.createElement(Thead, null,
            React.createElement(Tr, null,
                React.createElement(Th, { pl: 14 }, columnTitle),
                React.createElement(Th, null))),
        React.createElement(Tbody, null,
            React.createElement(Tr, { bg: "#F7FAFD" },
                React.createElement(Td, { p: "10px 16px" },
                    React.createElement(HStack, null,
                        React.createElement(Person, { color: "gray.400" }),
                        React.createElement(Box, { pl: 2 },
                            React.createElement(Text, { fontSize: "sm" }, userRequestJoin.email)))),
                React.createElement(Td, { align: "right" },
                    React.createElement(HStack, { justify: "flex-end", pr: 3 },
                        React.createElement(IconButton, { onClick: function () { return rejectRequest(); }, variant: "outline", borderRadius: 5, borderWidth: 2, "aria-label": "Reject", icon: React.createElement(X, null), isDisabled: !!loading }),
                        React.createElement(IconButton, { onClick: function () { return approveRequest(); }, variant: "outline", borderRadius: 5, borderWidth: 2, "aria-label": "Approved", icon: React.createElement(Check, null), isDisabled: !!loading })))))));
};
